import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { File } from '@app/models';
// import { getSelectedProducts } from '@app/modules/follow-detail/reducers/follow-detail.reducer';
import { FileActionTypes, FileActionsUnion } from '@core/actions/file.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<File> {
  loading: boolean;
  loaded: boolean;
  exporting: boolean;
  busy: boolean;
  spinnerMessage: string;
  templateUniqId: string;
}

export const adapter: EntityAdapter<File> = createEntityAdapter<File>({
  selectId: (file: File) => file.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  exporting: false,
  busy: false,
  spinnerMessage: null,
  templateUniqId: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: FileActionsUnion
) {
  switch (action.type) {
    case FileActionTypes.LoadByProductSuccess:
    case FileActionTypes.UpsertMany:
      return adapter.upsertMany(action.files, state);

    case FileActionTypes.AddOne:
      return adapter.addOne(action.file, state);

    case FileActionTypes.RemoveOne:
      return adapter.removeOne(action.id, state);

    case FileActionTypes.ExportFollow:
    case FileActionTypes.ExportOrderSummary:
    case FileActionTypes.ExportMasterKey:
    case FileActionTypes.ExportTotalSupplier:
    case FileActionTypes.ExportMP:
      return { ...state, exporting: true };

    case FileActionTypes.ExportMasterKeySuccess:
    case FileActionTypes.ExportMasterKeyFail:
    case FileActionTypes.ExportFollowSuccess:
    case FileActionTypes.ExportOrderSummarySuccess:
    case FileActionTypes.ExportFollowFail:
    case FileActionTypes.ExportOrderSummaryFail:
    case FileActionTypes.ExportMPSuccess:
    case FileActionTypes.ExportMPFail:
    case FileActionTypes.DownloadQuerySuccess:
    case FileActionTypes.DownloadQueryFail:
    case FileActionTypes.DownloadPostersSuccess:
      return { 
        ...state, 
        exporting: false, 
        loading: false,
        busy: false,
        spinnerMessage: null 
      };

    case FileActionTypes.DownloadImg:
    case FileActionTypes.ExportGlobalOcm:
    case FileActionTypes.ExportOcm:
    case FileActionTypes.DownloadQuery:
      return { ...state, busy: true };

    case FileActionTypes.DownloadRetroplanning:
      return { ...state, loading: true, busy: true };

    case FileActionTypes.ExportGlobalOcmPending:
      return { ...state, busy: true, spinnerMessage: action.data.message }

      case FileActionTypes.ExportGlobalOcmComplete:
        return { ...state, busy: false, spinnerMessage: null }

    case FileActionTypes.DownloadImgSuccess:
    case FileActionTypes.DownloadImgFail:
    // case FileActionTypes.ExportGlobalOcmSuccess:
    case FileActionTypes.ExportGlobalOcmFail:
    case FileActionTypes.ExportOcmFail:
      return { ...state, busy: false, spinnerMessage: null };

    case FileActionTypes.ExportOrderSummaryPending:
    case FileActionTypes.ExportFollowPending:
      return {
        ...state,
        loading: true,
        busy: true,
        spinnerMessage: action.data.message || ""
      };

    case FileActionTypes.DownloadRetroplanningSucces:
      return {
        ...state,
        loading: false,
        busy: false,
        spinnerMessage: 'Archivo descargado correctamente...'
      };
    case FileActionTypes.DownloadRetroplanningFail:
      return {
        ...state,
        loading: false,
        busy: false,
        spinnerMessage: 'no se puedo descargar el archivo'
      };
    case FileActionTypes.GetLinkRetroplanning:
      return { ...state, loading: true, busy: true };

    case FileActionTypes.GetLinkRetroplanningSuccess:
    case FileActionTypes.GetLinkRetroplanningFail:
      return {
        ...state,
        loading: false,
        busy: false
      };

    // case FileActionTypes.DownloadImgUpdate:
    //   return { ...state, busy: true, spinnerMessage: action.data.message}

    case FileActionTypes.ExportProforma:
      return { ...state, exporting: true };

    // case FileActionTypes.ExportProformaSuccess:
    // case FileActionTypes.ExportProformaFail:
    //   return { ...state, exporting: false, busy: false, spinnerMessage: null };

    case FileActionTypes.ExportHierarchyCountrySuccess:
    case FileActionTypes.ExportHierarchyCountryFail:
      return { ...state, exporting: false };

    case FileActionTypes.GetLinkHierarchyCountry:
      return {
        ...state,
        busy: true,
        spinnerMessage: 'Procesando Jerarquía'
      };

    case FileActionTypes.UploadHierarchyCountry:
      return {
        ...state,
        busy: true,
        spinnerMessage: 'Procesando Jerarquía'
      };
    case FileActionTypes.UploadHierarchyCountryUpdateSuccess:
      return {
        ...state,
        busy: false,
        spinnerMessage: ''
      };
    case FileActionTypes.UploadRetroplanning:
      return {
        ...state,
        busy: true,
        spinnerMessage: 'Procesando Retroplanning'
      };
    case FileActionTypes.UploadRetroplanningSuccess:
      return {
        ...state,
        loading: false,
        busy: false,
        spinnerMessage: 'Archivo cargado Correctamente'
      };

    case FileActionTypes.GenerateTemplateSuccess:
    case FileActionTypes.ExportProformaSuccess:
    case FileActionTypes.ExportProformaFail:
    case FileActionTypes.ExportProvidersSuccess:
      return {
        ...state,
        exporting: false,
        busy: false,
        spinnerMessage: null
      };

    case FileActionTypes.ExportProformaPending:
      return {
        ...state,
        busy: true,
        spinnerMessage: action.data.message || ''
      };

    case FileActionTypes.GenerateTemplate:
      return {
        ...state,
        exporting: true,
        spinnerMessage: action.data.message,
        templateUniqId: action.data.templateUniqId
        // uniqId: action.data.uniqId
      };

    case FileActionTypes.GenerateTemplateFail:
      return {
        ...state,
        exporting: false,
        spinnerMessage: 'Error al generar book!'
      };

    case FileActionTypes.UploadSingleImageFinalized:
      return {...state, busy: true,}

      case FileActionTypes.UploadSingleImageSecondSuccess:
      return {...state, busy: false,}

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectExporting = (state: State) => state.exporting;
export const getState = createFeatureSelector<State>('files');

export const getBusy = createSelector(
  getState,
  (state: State) => state.busy
);

export const getSpinnerMessage = createSelector(
  getState,
  (state: State) => state.spinnerMessage
);
